export const PRODUCT_CATEGORIES = [
  {
    id: "round",
    label: "Round Containers",
    blurb:
      "High-cavitation, food-grade round tubs with tamper-evident lids. Microwave-safe, freezer-friendly and stackable.",
    colors: ["Milky White", "Black", "Transparent", "Custom"],
    items: [
      {
        name: "Round Container",
        size: "300 ml",
        img: "/products/round-300.png",
        dims: "⌀112 × 93.2 · H 47.5 mm",
        use: "Individual portions — dips, chutneys, curd",
      },
      {
        name: "Round Container",
        size: "500 ml",
        img: "/products/round-500.png",
        dims: "⌀121 × 97.4 · H 63.5 mm",
        use: "Mid-size — raita, curries, desserts",
      },
      {
        name: "Round Container",
        size: "750 ml",
        img: "/products/round-750.png",
        dims: "⌀112 × 78 · H 125 mm",
        use: "Gravies, mains & combo meals",
      },
      {
        name: "Round Container",
        size: "1000 ml",
        img: "/products/round-1000.png",
        dims: "⌀158 × 105.3 · H 59 mm",
        use: "Family packs — biryani, bowls, salads",
      },
    ],
  },
  {
    id: "rect",
    label: "Rectangular Containers",
    blurb:
      "Rectangular takeaway boxes engineered for stacking and leak-resistant transport. Secure snap-fit lids across every size.",
    colors: ["Milky White", "Black", "Transparent", "Custom"],
    items: [
      {
        name: "Rectangular Container",
        size: "500 ml",
        img: "/products/rect-500.png",
        dims: "151.86 × 175.3 · H 37 mm",
        use: "Starters — kebabs, tikkas, snacks",
      },
      {
        name: "Rectangular Container",
        size: "750 ml",
        img: "/products/rect-750.png",
        dims: "95.46 × 119 · H 37 mm",
        use: "Dry sabzis, bakery & desserts",
      },
      {
        name: "Rectangular Container",
        size: "1000 ml",
        img: "/products/rect-1000.png",
        dims: "95.46 × 119 · H 80 mm",
        use: "Family platters & large portions",
      },
    ],
  },
  {
    id: "bubble",
    label: "Bubble Top Caps",
    blurb:
      "Precision bubble-top caps and PET preforms for 20L water dispenser bottles. Clean sealing, confident closure — available in two sizes.",
    colors: ["White", "Custom"],
    items: [
      {
        name: "Bubble Top Cap",
        size: "On 20L Bottle",
        img: "/products/bubble-bottle.png",
        dims: "Twist-less, leak-secure fit",
        use: "Water dispensers & jars",
      },
      {
        name: "Bubble Top Cap",
        size: "Detail",
        img: "/products/bubble-cap.png",
        dims: "Two neck sizes available",
        use: "Clean design · confident closure",
      },
    ],
  },
];

export const ROUND_FINISHES = [
  { label: "Milky White", img: "/products/round-white.png" },
  { label: "Black", img: "/products/round-black.png" },
  { label: "Transparent", img: "/products/round-clear.png" },
];
